import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AuthState, User } from "@/types/auth";

const initialState: AuthState = {
  error: null,
  isAuthenticated: false,
  isLoading: false,
  user: null,
};

const authSlice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    // Clear authentication state
    clearAuth: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;
      state.isLoading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    // Initialize user from token on app start
    initializeAuth: (state, action: PayloadAction<User>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.isLoading = false;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.user = null;
      state.error = action.payload;
    },
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (
      state,
      action: PayloadAction<{ token: string; user: User }>,
    ) => {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.error = null;
      // Store token in localStorage
      localStorage.setItem("auth_token", action.payload.token);
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;
      // Clear all auth-related data from localStorage
      localStorage.removeItem("auth_token");
      localStorage.removeItem("hareeng_user_profile");
      // Clear any user-specific profile data
      const keys = Object.keys(localStorage);
      keys.forEach((key) => {
        if (key.startsWith("user_profile_")) {
          localStorage.removeItem(key);
        }
      });
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    updateUser: (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
  },
});

export const {
  clearAuth,
  clearError,
  initializeAuth,
  loginFailure,
  loginStart,
  loginSuccess,
  logout,
  setLoading,
  updateUser,
} = authSlice.actions;

export default authSlice.reducer;
